import { Box, Card, List, Text } from '@ksyos/design-system';
import { PageTitle } from '../../elements/atoms/pageTitle/PageTitle';
import { PageWrapperWithHeader } from '../../elements/organisms/pageWrapper/PageWrapperWithHeader';

export function OsasMraHowToUseInformation() {
    return (
        <PageWrapperWithHeader>
            <PageTitle>Beugel (MRA): hoe werkt het</PageTitle>
            <Card>
                <Card.Body>
                    <Box maxWidth={620}>
                        <Box>
                            Je slaaparts van Ksyos heeft je doorverwezen naar een gespecialiseerde tandarts voor een
                            MRA-beugel. Dit is een beugel die je ’s nachts draagt. De beugel helpt om je luchtweg open
                            te houden tijdens het slapen.
                        </Box>
                        <Text
                            fontWeight="bold"
                            mb={2}
                            mt={4}
                            size="lg"
                        >
                            Stap 1 - Is de beugel geschikt?
                        </Text>
                        <Box mb={4}>
                            Bij de eerste afspraak kijkt de tandarts of de beugel bij je past. Hij of zij bekijkt:
                        </Box>
                        <List styleType="bullet">
                            <List.Item>De staat van jouw tanden en tandvlees</List.Item>
                            <List.Item>Of je genoeg tanden hebt om de beugel vast te maken</List.Item>
                            <List.Item>Je kaakgewricht en hoe jouw kaken bewegen</List.Item>
                        </List>
                        <Box mt={2}>
                            Is de beugel geschikt? Dan maakt de tandarts afdrukken of digitale scans van jouw gebit. Ook
                            meet de tandarts precies hoe jouw kaak staat.
                        </Box>
                        <Text
                            fontWeight="bold"
                            mb={2}
                            mt={4}
                            size="lg"
                        >
                            Stap 2 - Aanmeten en aanpassen
                        </Text>
                        <Box>
                            De beugel wordt op maat gemaakt in een tandtechnisch laboratorium. Dit duurt meestal 1 tot 2
                            weken. Bij het volgende bezoek plaatst de tandarts de beugel. Je krijgt uitleg over het in-
                            en uitdoen en over schoonmaken ervan.
                        </Box>
                        <Box>
                            In de eerste weken stelt de tandarts de beugel stap voor stap af. De onderkaak wordt iets
                            naar voren geplaatst. Zo gaat de luchtweg meer open. Dit gebeurt rustig en in kleine
                            stappen, tot het beste resultaat is bereikt.
                        </Box>
                        <Text
                            fontWeight="bold"
                            mb={2}
                            mt={4}
                            size="lg"
                        >
                            Wat kun je in het begin merken?
                        </Text>
                        <Box mb={4}>
                            Het wennen aan een beugel kost tijd. Veelvoorkomende bijwerkingen in de eerste weken zijn:
                        </Box>
                        <List styleType="bullet">
                            <List.Item>Te veel speeksel of juist een droge mond</List.Item>
                            <List.Item>Spierpijn in de kaak of stijfheid in de ochtend</List.Item>
                            <List.Item>
                                Tijdelijk een andere beet bij het opstaan (meestal binnen een uur weg)
                            </List.Item>
                            <List.Item>Lichte gevoeligheid van de tanden.</List.Item>
                        </List>
                        <Box mt={2}>Deze bijwerkingen zijn normaal en nemen bij de meeste mensen snel af.</Box>
                        <Text
                            fontWeight="bold"
                            mb={2}
                            mt={4}
                            size="lg"
                        >
                            Controles en follow-up
                        </Text>
                        <Box mb={4}>
                            Na het instellen van de beugel kom je regelmatig op controle bij de tandarts. Neem contact
                            op met Ksyos in de volgende gevallen:
                        </Box>
                        <List styleType="bullet">
                            <List.Item>De beugel is goed ingesteld maar je hebt nog klachten</List.Item>
                            <List.Item>
                                Je weet niet zeker of de beugel werkt. Eventueel wordt een slaaponderzoek herhaalt
                                terwijl je de beugel draagt.
                            </List.Item>
                            <List.Item>Je kunt niet wennen aan de beugel</List.Item>
                            <List.Item>Je kunt de beugel om een andere reden niet dragen</List.Item>
                        </List>
                        <Box mt={2}>Samen met de slaaparts bekijk je mogelijke alternatieven.</Box>
                    </Box>
                </Card.Body>
            </Card>
        </PageWrapperWithHeader>
    );
}
